import { parseISO, format } from 'date-fns';

const states = [
    { abbr: 'AL', state: 'Alabama' },
    { abbr: 'AK', state: 'Alaska' },
    { abbr: 'AZ', state: 'Arizona' },
    { abbr: 'AR', state: 'Arkansas' },
    { abbr: 'CA', state: 'California' },
    { abbr: 'CO', state: 'Colorado' },
    { abbr: 'CT', state: 'Connecticut' },
    { abbr: 'DE', state: 'Delaware' },
    { abbr: 'DC', state: 'District Of Columbia' },
    { abbr: 'FL', state: 'Florida' },
    { abbr: 'GA', state: 'Georgia' },
    { abbr: 'HI', state: 'Hawaii' },
    { abbr: 'ID', state: 'Idaho' },
    { abbr: 'IL', state: 'Illinois' },
    { abbr: 'IN', state: 'Indiana' },
    { abbr: 'IA', state: 'Iowa' },
    { abbr: 'KS', state: 'Kansas' },
    { abbr: 'KY', state: 'Kentucky' },
    { abbr: 'LA', state: 'Louisiana' },
    { abbr: 'ME', state: 'Maine' },
    { abbr: 'MD', state: 'Maryland' },
    { abbr: 'MA', state: 'Massachusetts' },
    { abbr: 'MI', state: 'Michigan' },
    { abbr: 'MN', state: 'Minnesota' },
    { abbr: 'MS', state: 'Mississippi' },
    { abbr: 'MO', state: 'Missouri' },
    { abbr: 'MT', state: 'Montana' },
    { abbr: 'NE', state: 'Nebraska' },
    { abbr: 'NV', state: 'Nevada' },
    { abbr: 'NH', state: 'New Hampshire' },
    { abbr: 'NJ', state: 'New Jersey' },
    { abbr: 'NM', state: 'New Mexico' },
    { abbr: 'NY', state: 'New York' },
    { abbr: 'NC', state: 'North Carolina' },
    { abbr: 'ND', state: 'North Dakota' },
    { abbr: 'OH', state: 'Ohio' },
    { abbr: 'OK', state: 'Oklahoma' },
    { abbr: 'OR', state: 'Oregon' },
    { abbr: 'PA', state: 'Pennsylvania' },
    { abbr: 'RI', state: 'Rhode Island' },
    { abbr: 'SC', state: 'South Carolina' },
    { abbr: 'SD', state: 'South Dakota' },
    { abbr: 'TN', state: 'Tennessee' },
    { abbr: 'TX', state: 'Texas' },
    { abbr: 'UT', state: 'Utah' },
    { abbr: 'VT', state: 'Vermont' },
    { abbr: 'VA', state: 'Virginia' },
    { abbr: 'WA', state: 'Washington' },
    { abbr: 'WV', state: 'West Virginia' },
    { abbr: 'WI', state: 'Wisconsin' },
    { abbr: 'WY', state: 'Wyoming' }
]

export const statesAbbr = states.map(element => ({ key: element.abbr, value: element.abbr, text: element.abbr }))

export const statesLong = states.map(element => ({ key: element.abbr, value: element.abbr, text: element.state }))

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const monthNumbers = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']

export const citationOrCase = ['Citation', 'Case Number'].map((c) => {
    return (
        { key: c, value: c, text: c }
    )
})

export const monthOptions = months.map((m, index) => {
    return (
        { key: m, value: index + 1, text: m }
    )
})

export const monthNumberOptions = monthNumbers.map((m, index) => {
    return (
        { key: m, value: index + 1, text: m }
    )
})

const yearsDOB = () => {
    const currentYear = new Date().getFullYear()
    const yr = []
    for (let x = currentYear - 10; x >= currentYear - 100; x--) {
        yr.push(x)
    }
    return yr
}

export const yearDOBOptions = yearsDOB().map((y) => {
    return (
        { key: y, value: y, text: y }
    )
})


export const yearsCard = () => {
    const currentYear = new Date().getFullYear()
    const yr = ['']
    for (let x = currentYear; x <= currentYear + 10; x++) {
        yr.push('' + x)
    }
    return yr
}

export const yearCardOptions = yearsCard().map((y) => {
    return (
        { key: y, value: y, text: y }
    )
})

export const days = () => {
    const dys = []
    for (let x = 1; x <= 31; x++) {
        dys.push(x)
    }
    return dys
}

export const dayOptions = days().map((d) => {
    return (
        { key: d, value: d, text: d }
    )
})

export const simpleCurrencyFormat = (amount) => {
    return Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount)
}

export const getUniqueArray = (array) => {
    return [...new Set(array)];
}

export const getDate = (inDate) => {
    let returnDate = inDate
    try {
        const parsedDate = Date.parse(inDate + 'T00:00:00')
        returnDate = new Intl.DateTimeFormat('en-US').format(new Date(parsedDate))
    } catch (err) {

    }
    return returnDate
}

export const getCurrency = (inAmount) => {
    let returnAmount = inAmount
    try {
        const formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'})
        returnAmount = formatter.format(inAmount)
    } catch (err) {
    }
    return returnAmount
}

export const getDecimal = (inAmount, useGrouping = true) => {
    let returnAmount = inAmount;
    try {
        const formatter = new Intl.NumberFormat('en-US', {style: 'decimal', minimumFractionDigits: 2, useGrouping: useGrouping})
        returnAmount = formatter.format(inAmount)
    } catch (err) {
    }
    return returnAmount;
}

export const validateEmail = (inEmail) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(inEmail))
    {
        return true;
    }
    return false;
}

export const convertDateStringToDisplay = (dateIn) => {
    if (dateIn) return format(parseISO(dateIn), 'MM/dd/yyyy');
    return '';
}
